var _effectorFileName = "/builds/gmini/front-chm-api-sdk/src/Instance.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { InstanceStatus } from './InstanceStatus';
import { AssigneeSourceIO } from './assigneeSource.enum';
import { ApiDomain } from './domain';
export var Instance;
(function (_Instance) {
  var domain = ApiDomain.domain('Instance', {
    name: "domain",
    sid: "-mlma"
  });
  var Assignee = _Instance.Assignee = t.type({
    id: t.number,
    source: AssigneeSourceIO,
    instanceId: t.number,
    assigneeId: t.string
  });
  var CommonInstanceProperties = _Instance.CommonInstanceProperties = t.type({
    id: t.number,
    version: t.number,
    templateId: t.union([t.number, t.undefined]),
    templateVersion: t.union([t.number, t.undefined]),
    templateTypeId: t.union([t.number, t["null"]]),
    name: t.string,
    description: t.string,
    deleted: t["boolean"],
    status: InstanceStatus.io,
    createdAt: t.union([t.string, t.undefined]),
    updatedAt: t.union([t.string, t.undefined]),
    ownerId: t.union([t.string, t["null"]]),
    projectUrn: t.string,
    assignees: t.array(Assignee)
  });
  var Instance = _Instance.Instance = t.intersection([CommonInstanceProperties, t.type({
    type: t.literal('Instance')
  })]);
  var SectionItemFile = _Instance.SectionItemFile = t.type({
    id: t.number,
    s3Key: t.string,
    instanceId: t.number,
    templateSectionItemId: t.number,
    instanceVersion: t.number,
    name: t.string,
    uploadAt: t.string
  });
  var SectionItemAnswer = _Instance.SectionItemAnswer = t.union([t.literal('YES'), t.literal('NO'), t.literal('NO_ANSWER')]);
  var InstanceItemProperty = _Instance.InstanceItemProperty = t.type({
    answer: SectionItemAnswer,
    templateSectionItemId: t.number
  });
  var InstancePopulated = _Instance.InstancePopulated = t.intersection([CommonInstanceProperties, t.type({
    type: t.literal('InstancePopulated'),
    itemProperties: t.array(InstanceItemProperty)
  })]);
  var Data = _Instance.Data = t.type({
    list: t.array(Instance),
    total: t.number
  });
  var fetchList = _Instance.fetchList = ApiCallService.create({
    name: 'fetchList',
    parentDomain: domain,
    result: Data,
    getKey: ['offset', 'limit', 'filter', 'projectUrn']
  });
  var FilterAssignee = _Instance.FilterAssignee = t.type({
    assigneeId: t.string,
    source: AssigneeSourceIO
  });
  var FetchAllowedFiltersResponse = _Instance.FetchAllowedFiltersResponse = t.type({
    assignees: t.array(FilterAssignee),
    ownerIds: t.array(t.string),
    statuses: t.array(InstanceStatus.io),
    templateTypeIds: t.array(t.number),
    createdDateRange: t.union([t.tuple([t.string, t.string]), t["null"]]),
    updatedDateRange: t.union([t.tuple([t.string, t.string]), t["null"]])
  });
  var fetchAllowedFilters = _Instance.fetchAllowedFilters = ApiCallService.create({
    name: 'fetchAllowedFilters',
    parentDomain: domain,
    result: FetchAllowedFiltersResponse,
    getKey: ['projectUrn']
  });
  var fetch = _Instance.fetch = ApiCallService.create({
    name: 'fetch',
    parentDomain: domain,
    result: InstancePopulated,
    getKey: ['id', 'version']
  });
  var fetchMostRecent = _Instance.fetchMostRecent = ApiCallService.create({
    name: 'fetchMostRecent',
    parentDomain: domain,
    result: InstancePopulated,
    getKey: ['id']
  });
  var AssigneeParam = _Instance.AssigneeParam = t.type({
    source: AssigneeSourceIO,
    assigneeId: t.string
  });
  var create = _Instance.create = ApiCallService.create({
    name: 'create',
    parentDomain: domain,
    result: InstancePopulated,
    getKey: ['description', 'name', 'templateId', 'templateVersion', 'projectUrn']
  });
  var update = _Instance.update = ApiCallService.create({
    name: 'update',
    parentDomain: domain,
    result: InstancePopulated,
    getKey: ['id', 'version']
  });
  var closeStatus = _Instance.closeStatus = ApiCallService.create({
    name: 'closeStatus',
    parentDomain: domain,
    result: InstancePopulated,
    getKey: ['id', 'version']
  });
  var updateAnswer = _Instance.updateAnswer = ApiCallService.create({
    name: 'updateAnswer',
    parentDomain: domain,
    result: InstancePopulated,
    getKey: ['id', 'version', 'answer', 'templateSectionItemId']
  });
  var remove = _Instance.remove = ApiCallService.create({
    name: 'remove',
    parentDomain: domain,
    result: InstancePopulated,
    getKey: ['id', 'version']
  });
  var startUploadSectionItemFile = _Instance.startUploadSectionItemFile = ApiCallService.create({
    name: 'startUploadSectionItemFile',
    parentDomain: domain,
    result: Instance,
    getKey: ['instanceId', 'instanceVersion']
  });
  var uploadSectionItemFile = _Instance.uploadSectionItemFile = ApiCallService.create({
    name: 'uploadSectionItemFile',
    parentDomain: domain,
    result: SectionItemFile,
    getKey: ['instanceId', 'instanceVersion', 'templateSectionItemId']
  });
  var deleteSectionItemFile = _Instance.deleteSectionItemFile = ApiCallService.create({
    name: 'deleteSectionItemFile',
    parentDomain: domain,
    result: SectionItemFile,
    getKey: ['fileId', 'instanceId', 'instanceVersion']
  });
  var fetchSectionItemFileList = _Instance.fetchSectionItemFileList = ApiCallService.create({
    name: 'fetchSectionItemFileList',
    parentDomain: domain,
    result: t.array(SectionItemFile),
    getKey: ['instanceId', 'instanceVersion', 'templateSectionItemId']
  });
  var downloadSectionItemFile = _Instance.downloadSectionItemFile = ApiCallService.create({
    name: 'downloadSectionItemFile',
    parentDomain: domain,
    result: t.string,
    getKey: ['fileId']
  });
})(Instance || (Instance = {}));